import React from "react";
import { bind } from "decko";
import DateTimePicker from "react-datetime-picker";
import DialogOverlay from "./DialogOverlay";

function StoppageItem ({ts, idx, onChange, onDelete}) {
    let minDate = new Date(ts);
    let maxDate = new Date(ts);
    minDate.setMonth(0, 1);
    maxDate.setMonth(11, 31);
    return (
        <div className="col-xs-6">
            {ts && (
                <span>
                    <DateTimePicker
                        className="datetime-picker-no-outline"
                        onChange={(v) => onChange(idx, v)}
                        disableClock
                        locale="sv-se"
                        clearIcon={null}
                        minDate={minDate}
                        maxDate={maxDate}
                        minDetail="month"
                        maxDetail="second"
                        value={ts}
                    />
                </span>
            )}
            {onDelete && (
                <a className="close text-outline" title="Remove entry" onClick={onDelete}>
                    <span className="glyphicon glyphicon-remove" />
                </a>
            )}
        </div>
    );
}

export default class StopClockOverlay extends React.Component {
    constructor (props) {
        super(props);

        let stops = props.game.stop_periods.map(s => new Date(s));

        this.state = {
            stops: stops,
            isStopped: stops.length % 2 === 1,
            error: null,
        };
    }

    @bind
    save (callback=null) {
        const url = "/game/" + this.props.game.id;
        const strStopPeriods = this.state.stops.map(ts => ts.toISOString());
        const body = {
            stop_periods: strStopPeriods
        };
        console.log("Updating match halts:", url, body);
        this.props.server.put(url, body, () => {
            console.log("Successfully updated");
            // It would re-sync eventually, but make it instant
            this.props.game.stop_periods = strStopPeriods;
            if (typeof  callback === "function") callback();
        }, (error) => {
            this.setState({error: "Failed to update: " + error});
        });
    }

    @bind
    addEntry () {
        let stops = this.state.stops.slice(0);
        const ts = this.props.getTimestamp();
        if (stops.length > 0 && ts < stops[stops.length-1]) {
            this.setState({
                error: "Timestamp must be after the last stop",
            });
            return;
        }
        stops.push(ts);
        this.setState({
            stops: stops,
            isStopped: stops.length % 2 === 1,
            error: null,
        });
    }

    @bind
    onChange (idx, newTimestamp) {
        console.log("Changing timestamp idx", idx, "to", newTimestamp);
        let stops = this.state.stops.slice(0);
        const prev = stops[idx-1];
        const next = stops[idx+1];
        if (prev && newTimestamp < prev) {
            this.setState({
                error: "Timestamp must be after the last stop",
            });
            return;
        }
        if (next && newTimestamp > next) {
            this.setState({
                error: "Timestamp must be before the next stop",
            });
            return;
        }
        stops[idx] = newTimestamp;
        this.setState({stops: stops, error: null});
    }

    @bind
    onDeleteLast () {
        let stops = this.state.stops.slice(0, -1);
        this.setState({
            stops: stops,
            isStopped: stops.length % 2 === 1,
            error: null,
        });
    }

    render () {
        return (
            <DialogOverlay
                hotkeyHandler={this.props.hotkeyHandler}
                submitText="Save & close"
                onSubmit={() => this.save(this.props.onDone)}
                secondarySubmitText="Save"
                onSecondarySubmit={() => this.save()}
                onCancel={this.props.onDone}>
                <a className="special-stoppage-btn active btn btn-xs btn-default btn-transparent text-outline"
                   onClick={this.props.onCancel}>
                    Halt match
                </a>
                <div className="row" style={{marginBottom: "20px"}}>
                    <div className="col-xs-12 text-center text-capitalize">
                        Extra match breaks
                    </div>
                    <div className="col-xs-12 text-center text-small" style={{marginBottom: "16px"}}>
                        Rare cases where match is interrupted halfway through.
                        Due to extreme weather, power outages or similar special circumstances.
                        Can be stopped for potentially multiple days.
                        Once restarted, adjust start/stop until match clock looks accurate.
                    </div>
                    <div className="col-xs-12">
                        {this.state.stops.map((ts, idx) => (
                            <StoppageItem
                                key={idx}
                                ts={ts}
                                idx={idx}
                                canDelete={idx === this.state.stops.length - 1}
                                onChange={this.onChange}
                                onDelete={(idx === this.state.stops.length - 1) ? this.onDeleteLast : null} />
                        ))}
                        <div className="col-xs-6 text-center">
                            <button className="fullwidth btn btn-transparent btn-default text-outline" onClick={this.addEntry}>
                                {this.state.isStopped ? "Resume match clock" : "Halt match clock"}
                            </button>
                        </div>
                    </div>
                    {this.state.error && (
                        <div className="col-xs-12 match-info-invalid text-center">
                            {this.state.error}
                        </div>
                    )}
                </div>
            </DialogOverlay>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/StopClockOverlay.js